
const teamSectionStyle = {
  buttonContainer: {
    justifyContent: "center",
    display: { xs: "flex", md: "none" },
    marginTop: "1rem",
    scrollMarginTop: "20rem",
  },
};

export default teamSectionStyle;
